__turbopack_context__.v({
  "className": "noto_serif_9e1b11c9-module__sCUYRa__className",
});
